// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/images/bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.0 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: currentColor; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden] {
  display: none;
}

@media screen and (max-width: 768px) {
        .background {
            background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
            background-size: 800px;
        }
    }

@media screen and (max-width: 1024px) {
        .background {
            background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
            background-size: 800px;
        }
    }

@media screen and (min-width: 1025px) {
        .background {
            background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
            background-size: 1000px;
        }
    }

:root {
    --background: 0 0% 100%;
    --foreground: 222.2 84% 4.9%;

    --card: 0 0% 100%;
    --card-foreground: 222.2 84% 4.9%;

    --popover: 0 0% 100%;
    --popover-foreground: 222.2 84% 4.9%;

    --primary: #0193EB;
    --primary-foreground: 210 40% 98%;

    --secondary: #2C2C2C;
    --secondary-foreground: 222.2 47.4% 11.2%;

    --muted: 210 40% 96.1%;
    --muted-foreground: 215.4 16.3% 46.9%;

    --accent: 210 40% 96.1%;
    --accent-foreground: 222.2 47.4% 11.2%;

    --destructive: 0 84.2% 60.2%;
    --destructive-foreground: 210 40% 98%;

    --border: 214.3 31.8% 91.4%;
    --input: 214.3 31.8% 91.4%;
    --ring: 222.2 84% 4.9%;

    --radius: 0.5rem;

      --modal-background: rgba(44, 44, 44, 0.32);
      --gray: #667A8B;
      --text-gray: #8A8B9A;

      --success: #3ED078;
  }

*{
  border-color: hsl(var(--border));
  font-family: Inter, sans-serif;
}

body{
  background-color: hsl(var(--background));
  color: var(--secondary);
}

*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.pointer-events-auto{
  pointer-events: auto;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.\\!left-0{
  left: 0px !important;
}
.left-0{
  left: 0px;
}
.left-1\\/2{
  left: 50%;
}
.left-2{
  left: 0.5rem;
}
.left-\\[-1px\\]{
  left: -1px;
}
.right-0{
  right: 0px;
}
.right-2{
  right: 0.5rem;
}
.top-0{
  top: 0px;
}
.top-2{
  top: 0.5rem;
}
.top-\\[-20px\\]{
  top: -20px;
}
.top-\\[-60px\\]{
  top: -60px;
}
.top-\\[56px\\]{
  top: 56px;
}
.z-10{
  z-index: 10;
}
.z-30{
  z-index: 30;
}
.z-50{
  z-index: 50;
}
.z-\\[-1\\]{
  z-index: -1;
}
.z-\\[100\\]{
  z-index: 100;
}
.z-\\[1\\]{
  z-index: 1;
}
.z-\\[2\\]{
  z-index: 2;
}
.-mx-1{
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.mx-1{
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-4{
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-\\[36px\\]{
  margin-top: 36px;
  margin-bottom: 36px;
}
.my-auto{
  margin-top: auto;
  margin-bottom: auto;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.mb-\\[30px\\]{
  margin-bottom: 30px;
}
.mb-\\[64px\\]{
  margin-bottom: 64px;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-auto{
  margin-left: auto;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-3{
  margin-right: 0.75rem;
}
.mr-4{
  margin-right: 1rem;
}
.mt-0{
  margin-top: 0px;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-\\[40px\\]{
  margin-top: 40px;
}
.mt-\\[56px\\]{
  margin-top: 56px;
}
.mt-auto{
  margin-top: auto;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-2{
  height: 0.5rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-4{
  height: 1rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-\\[100px\\]{
  height: 100px;
}
.h-\\[142px\\]{
  height: 142px;
}
.h-\\[156px\\]{
  height: 156px;
}
.h-\\[16px\\]{
  height: 16px;
}
.h-\\[170px\\]{
  height: 170px;
}
.h-\\[1px\\]{
  height: 1px;
}
.h-\\[228px\\]{
  height: 228px;
}
.h-\\[24px\\]{
  height: 24px;
}
.h-\\[26px\\]{
  height: 26px;
}
.h-\\[28px\\]{
  height: 28px;
}
.h-\\[30px\\]{
  height: 30px;
}
.h-\\[32px\\]{
  height: 32px;
}
.h-\\[40px\\]{
  height: 40px;
}
.h-\\[48px\\]{
  height: 48px;
}
.h-\\[56px\\]{
  height: 56px;
}
.h-\\[600px\\]{
  height: 600px;
}
.h-\\[70px\\]{
  height: 70px;
}
.h-fit{
  height: -moz-fit-content;
  height: fit-content;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.h-screen{
  height: 100vh;
}
.max-h-\\[18px\\]{
  max-height: 18px;
}
.max-h-\\[20px\\]{
  max-height: 20px;
}
.max-h-\\[560px\\]{
  max-height: 560px;
}
.max-h-\\[80px\\]{
  max-height: 80px;
}
.max-h-screen{
  max-height: 100vh;
}
.min-h-\\[500px\\]{
  min-height: 500px;
}
.min-h-\\[640px\\]{
  min-height: 640px;
}
.min-h-\\[850px\\]{
  min-height: 850px;
}
.w-10{
  width: 2.5rem;
}
.w-2{
  width: 0.5rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-3\\/6{
  width: 50%;
}
.w-4{
  width: 1rem;
}
.w-56{
  width: 14rem;
}
.w-6\\/12{
  width: 50%;
}
.w-72{
  width: 18rem;
}
.w-\\[156px\\]{
  width: 156px;
}
.w-\\[16px\\]{
  width: 16px;
}
.w-\\[220px\\]{
  width: 220px;
}
.w-\\[24px\\]{
  width: 24px;
}
.w-\\[250px\\]{
  width: 250px;
}
.w-\\[26px\\]{
  width: 26px;
}
.w-\\[28px\\]{
  width: 28px;
}
.w-\\[320px\\]{
  width: 320px;
}
.w-\\[32px\\]{
  width: 32px;
}
.w-\\[40px\\]{
  width: 40px;
}
.w-\\[66px\\]{
  width: 66px;
}
.w-auto{
  width: auto;
}
.w-fit{
  width: -moz-fit-content;
  width: fit-content;
}
.w-full{
  width: 100%;
}
.min-w-\\[8rem\\]{
  min-width: 8rem;
}
.max-w-\\[1120px\\]{
  max-width: 1120px;
}
.max-w-\\[1440px\\]{
  max-width: 1440px;
}
.max-w-\\[18px\\]{
  max-width: 18px;
}
.max-w-\\[20px\\]{
  max-width: 20px;
}
.max-w-\\[900px\\]{
  max-width: 900px;
}
.max-w-none{
  max-width: none;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink-0{
  flex-shrink: 0;
}
.flex-grow{
  flex-grow: 1;
}
.grow{
  flex-grow: 1;
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-default{
  cursor: default;
}
.cursor-pointer{
  cursor: pointer;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.resize{
  resize: both;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.flex-col{
  flex-direction: column;
}
.flex-col-reverse{
  flex-direction: column-reverse;
}
.flex-wrap{
  flex-wrap: wrap;
}
.items-center{
  align-items: center;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-0{
  gap: 0px;
}
.gap-0\\.5{
  gap: 0.125rem;
}
.gap-1{
  gap: 0.25rem;
}
.gap-12{
  gap: 3rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-8{
  gap: 2rem;
}
.gap-x-6{
  column-gap: 1.5rem;
}
.gap-y-4{
  row-gap: 1rem;
}
.space-x-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.overflow-hidden{
  overflow: hidden;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-lg{
  border-radius: var(--radius);
}
.rounded-md{
  border-radius: calc(var(--radius) - 2px);
}
.rounded-sm{
  border-radius: calc(var(--radius) - 4px);
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-b-lg{
  border-bottom-right-radius: var(--radius);
  border-bottom-left-radius: var(--radius);
}
.rounded-b-none{
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-r-full{
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}
.rounded-br-full{
  border-bottom-right-radius: 9999px;
}
.rounded-tl-\\[1300px\\]{
  border-top-left-radius: 1300px;
}
.rounded-tl-none{
  border-top-left-radius: 0px;
}
.rounded-tr-full{
  border-top-right-radius: 9999px;
}
.border{
  border-width: 1px;
}
.border-none{
  border-style: none;
}
.\\!border-\\[\\#D6D9E0\\]{
  --tw-border-opacity: 1 !important;
  border-color: rgb(214 217 224 / var(--tw-border-opacity)) !important;
}
.border-\\[\\#E6E6E6\\]{
  --tw-border-opacity: 1;
  border-color: rgb(230 230 230 / var(--tw-border-opacity));
}
.border-destructive{
  border-color: hsl(var(--destructive));
}
.border-input{
  border-color: hsl(var(--input));
}
.border-transparent{
  border-color: transparent;
}
.bg-\\[\\#DDD\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(221 221 221 / var(--tw-bg-opacity));
}
.bg-\\[\\#E5F1F8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(229 241 248 / var(--tw-bg-opacity));
}
.bg-\\[\\#E7F6FF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(231 246 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#E8F6FF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(232 246 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#ECF5FB\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(236 245 251 / var(--tw-bg-opacity));
}
.bg-\\[\\#F4FBFF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(244 251 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#F9F9F9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(249 249 249 / var(--tw-bg-opacity));
}
.bg-background{
  background-color: hsl(var(--background));
}
.bg-destructive{
  background-color: hsl(var(--destructive));
}
.bg-modal-background{
  background-color: var(--modal-background);
}
.bg-muted{
  background-color: hsl(var(--muted));
}
.bg-popover{
  background-color: hsl(var(--popover));
}
.bg-primary{
  background-color: var(--primary);
}
.bg-secondary{
  background-color: var(--secondary);
}
.bg-success{
  background-color: var(--success);
}
.bg-transparent{
  background-color: transparent;
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.fill-current{
  fill: currentColor;
}
.object-cover{
  object-fit: cover;
}
.p-1{
  padding: 0.25rem;
}
.p-2{
  padding: 0.5rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.px-0{
  padding-left: 0px;
  padding-right: 0px;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.pb-8{
  padding-bottom: 2rem;
}
.pb-\\[120px\\]{
  padding-bottom: 120px;
}
.pb-\\[24px\\]{
  padding-bottom: 24px;
}
.pb-\\[32px\\]{
  padding-bottom: 32px;
}
.pb-\\[40px\\]{
  padding-bottom: 40px;
}
.pb-\\[44px\\]{
  padding-bottom: 44px;
}
.pb-\\[64px\\]{
  padding-bottom: 64px;
}
.pb-\\[80px\\]{
  padding-bottom: 80px;
}
.pl-10{
  padding-left: 2.5rem;
}
.pl-12{
  padding-left: 3rem;
}
.pl-5{
  padding-left: 1.25rem;
}
.pl-8{
  padding-left: 2rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-8{
  padding-right: 2rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-4{
  padding-top: 1rem;
}
.pt-\\[40px\\]{
  padding-top: 40px;
}
.pt-\\[64px\\]{
  padding-top: 64px;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.leading-\\[24px\\]{
  line-height: 24px;
}
.tracking-widest{
  letter-spacing: 0.1em;
}
.text-\\[\\#0193EB\\]{
  --tw-text-opacity: 1;
  color: rgb(1 147 235 / var(--tw-text-opacity));
}
.text-\\[\\#58839D\\]{
  --tw-text-opacity: 1;
  color: rgb(88 131 157 / var(--tw-text-opacity));
}
.text-destructive-foreground{
  color: hsl(var(--destructive-foreground));
}
.text-foreground{
  color: hsl(var(--foreground));
}
.text-foreground\\/50{
  color: hsl(var(--foreground) / 0.5);
}
.text-gray{
  color: var(--gray);
}
.text-popover-foreground{
  color: hsl(var(--popover-foreground));
}
.text-primary{
  color: var(--primary);
}
.text-primary-foreground{
  color: hsl(var(--primary-foreground));
}
.text-secondary{
  color: var(--secondary);
}
.text-secondary-foreground{
  color: hsl(var(--secondary-foreground));
}
.text-text-gray{
  color: var(--text-gray);
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.underline-offset-4{
  text-underline-offset: 4px;
}
.opacity-0{
  opacity: 0;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-90{
  opacity: 0.9;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.ring-offset-background{
  --tw-ring-offset-color: hsl(var(--background));
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-300{
  transition-duration: 300ms;
}
@keyframes enter{

  from{
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit{

  to{
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.duration-300{
  animation-duration: 300ms;
}

.file\\:border-0::file-selector-button{
  border-width: 0px;
}

.file\\:bg-transparent::file-selector-button{
  background-color: transparent;
}

.file\\:text-sm::file-selector-button{
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.file\\:font-medium::file-selector-button{
  font-weight: 500;
}

.placeholder\\:text-gray::placeholder{
  color: var(--gray);
}

.placeholder\\:text-muted-foreground::placeholder{
  color: hsl(var(--muted-foreground));
}

.placeholder\\:text-text-gray::placeholder{
  color: var(--text-gray);
}

.hover\\:border-primary:hover{
  border-color: var(--primary);
}

.hover\\:bg-\\[\\#ECF8FF\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(236 248 255 / var(--tw-bg-opacity));
}

.hover\\:bg-\\[\\#F6FCFF\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(246 252 255 / var(--tw-bg-opacity));
}

.hover\\:bg-accent:hover{
  background-color: hsl(var(--accent));
}

.hover\\:bg-destructive\\/90:hover{
  background-color: hsl(var(--destructive) / 0.9);
}

.hover\\:bg-secondary:hover{
  background-color: var(--secondary);
}

.hover\\:text-accent-foreground:hover{
  color: hsl(var(--accent-foreground));
}

.hover\\:text-foreground:hover{
  color: hsl(var(--foreground));
}

.hover\\:text-primary:hover{
  color: var(--primary);
}

.hover\\:text-secondary:hover{
  color: var(--secondary);
}

.hover\\:underline:hover{
  text-decoration-line: underline;
}

.hover\\:opacity-70:hover{
  opacity: 0.7;
}

.hover\\:shadow-none:hover{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:bg-accent:focus{
  background-color: hsl(var(--accent));
}

.focus\\:text-accent-foreground:focus{
  color: hsl(var(--accent-foreground));
}

.focus\\:opacity-100:focus{
  opacity: 1;
}

.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-ring:focus{
  --tw-ring-color: hsl(var(--ring));
}

.focus\\:ring-offset-2:focus{
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:bg-\\[\\#ECF8FF\\]:focus-visible{
  --tw-bg-opacity: 1;
  background-color: rgb(236 248 255 / var(--tw-bg-opacity));
}

.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:\\!ring-transparent:focus-visible{
  --tw-ring-color: transparent !important;
}

.focus-visible\\:ring-ring:focus-visible{
  --tw-ring-color: hsl(var(--ring));
}

.focus-visible\\:ring-offset-2:focus-visible{
  --tw-ring-offset-width: 2px;
}

.active\\:bg-\\[\\#ECF8FF\\]:active{
  --tw-bg-opacity: 1;
  background-color: rgb(236 248 255 / var(--tw-bg-opacity));
}

.disabled\\:pointer-events-none:disabled{
  pointer-events: none;
}

.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}

.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}

.group:hover .group-hover\\:-rotate-45{
  --tw-rotate: -45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}

.group.destructive .group-\\[\\.destructive\\]\\:border-muted\\/40{
  border-color: hsl(var(--muted) / 0.4);
}

.group.destructive .group-\\[\\.destructive\\]\\:text-red-300{
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity));
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:border-destructive\\/30:hover{
  border-color: hsl(var(--destructive) / 0.3);
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:bg-destructive:hover{
  background-color: hsl(var(--destructive));
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-destructive-foreground:hover{
  color: hsl(var(--destructive-foreground));
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-red-50:hover{
  --tw-text-opacity: 1;
  color: rgb(254 242 242 / var(--tw-text-opacity));
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-destructive:focus{
  --tw-ring-color: hsl(var(--destructive));
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-red-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity));
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-offset-red-600:focus{
  --tw-ring-offset-color: #dc2626;
}

.peer:focus ~ .peer-focus\\:text-secondary{
  color: var(--secondary);
}

.data-\\[disabled\\]\\:pointer-events-none[data-disabled]{
  pointer-events: none;
}

.data-\\[swipe\\=cancel\\]\\:translate-x-0[data-swipe=cancel]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=end\\]\\:translate-x-\\[var\\(--radix-toast-swipe-end-x\\)\\][data-swipe=end]{
  --tw-translate-x: var(--radix-toast-swipe-end-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=move\\]\\:translate-x-\\[var\\(--radix-toast-swipe-move-x\\)\\][data-swipe=move]{
  --tw-translate-x: var(--radix-toast-swipe-move-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=open\\]\\:bg-accent[data-state=open]{
  background-color: hsl(var(--accent));
}

.data-\\[disabled\\]\\:opacity-50[data-disabled]{
  opacity: 0.5;
}

.data-\\[swipe\\=move\\]\\:transition-none[data-swipe=move]{
  transition-property: none;
}

.data-\\[state\\=open\\]\\:animate-in[data-state=open]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}

.data-\\[state\\=closed\\]\\:animate-out[data-state=closed]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[swipe\\=end\\]\\:animate-out[data-swipe=end]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[state\\=closed\\]\\:fade-out-0[data-state=closed]{
  --tw-exit-opacity: 0;
}

.data-\\[state\\=closed\\]\\:fade-out-80[data-state=closed]{
  --tw-exit-opacity: 0.8;
}

.data-\\[state\\=open\\]\\:fade-in-0[data-state=open]{
  --tw-enter-opacity: 0;
}

.data-\\[state\\=closed\\]\\:zoom-out-95[data-state=closed]{
  --tw-exit-scale: .95;
}

.data-\\[state\\=open\\]\\:zoom-in-95[data-state=open]{
  --tw-enter-scale: .95;
}

.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side=bottom]{
  --tw-enter-translate-y: -0.5rem;
}

.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side=left]{
  --tw-enter-translate-x: 0.5rem;
}

.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side=right]{
  --tw-enter-translate-x: -0.5rem;
}

.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side=top]{
  --tw-enter-translate-y: 0.5rem;
}

.data-\\[state\\=closed\\]\\:slide-out-to-right-full[data-state=closed]{
  --tw-exit-translate-x: 100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-top-full[data-state=open]{
  --tw-enter-translate-y: -100%;
}

@media (min-width: 540px){

  .min-\\[540px\\]\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .min-\\[540px\\]\\:gap-x-6{
    column-gap: 1.5rem;
  }
}

@media (min-width: 640px){

  .sm\\:bottom-0{
    bottom: 0px;
  }

  .sm\\:right-0{
    right: 0px;
  }

  .sm\\:top-auto{
    top: auto;
  }

  .sm\\:flex-col{
    flex-direction: column;
  }

  .data-\\[state\\=open\\]\\:sm\\:slide-in-from-bottom-full[data-state=open]{
    --tw-enter-translate-y: 100%;
  }

  .tablet\\:top-\\[-15px\\]{
    top: -15px;
  }

  .tablet\\:top-\\[-25px\\]{
    top: -25px;
  }

  .tablet\\:m-0{
    margin: 0px;
  }

  .tablet\\:mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }

  .tablet\\:mx-auto{
    margin-left: auto;
    margin-right: auto;
  }

  .tablet\\:mb-4{
    margin-bottom: 1rem;
  }

  .tablet\\:mb-8{
    margin-bottom: 2rem;
  }

  .tablet\\:mb-\\[18px\\]{
    margin-bottom: 18px;
  }

  .tablet\\:mb-\\[48px\\]{
    margin-bottom: 48px;
  }

  .tablet\\:ml-auto{
    margin-left: auto;
  }

  .tablet\\:mr-6{
    margin-right: 1.5rem;
  }

  .tablet\\:mt-\\[72px\\]{
    margin-top: 72px;
  }

  .tablet\\:block{
    display: block;
  }

  .tablet\\:flex{
    display: flex;
  }

  .tablet\\:hidden{
    display: none;
  }

  .tablet\\:h-\\[100px\\]{
    height: 100px;
  }

  .tablet\\:h-\\[180px\\]{
    height: 180px;
  }

  .tablet\\:h-\\[220px\\]{
    height: 220px;
  }

  .tablet\\:h-\\[36px\\]{
    height: 36px;
  }

  .tablet\\:h-\\[800px\\]{
    height: 800px;
  }

  .tablet\\:h-\\[80px\\]{
    height: 80px;
  }

  .tablet\\:max-h-\\[480px\\]{
    max-height: 480px;
  }

  .tablet\\:min-h-\\[1000px\\]{
    min-height: 1000px;
  }

  .tablet\\:w-\\[220px\\]{
    width: 220px;
  }

  .tablet\\:w-\\[600px\\]{
    width: 600px;
  }

  .tablet\\:w-\\[90px\\]{
    width: 90px;
  }

  .tablet\\:max-w-\\[140px\\]{
    max-width: 140px;
  }

  .tablet\\:max-w-\\[224px\\]{
    max-width: 224px;
  }

  .tablet\\:max-w-\\[660px\\]{
    max-width: 660px;
  }

  .tablet\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .tablet\\:flex-row{
    flex-direction: row;
  }

  .tablet\\:items-center{
    align-items: center;
  }

  .tablet\\:gap-1{
    gap: 0.25rem;
  }

  .tablet\\:gap-4{
    gap: 1rem;
  }

  .tablet\\:gap-6{
    gap: 1.5rem;
  }

  .tablet\\:gap-x-6{
    column-gap: 1.5rem;
  }

  .tablet\\:rounded-tl-\\[1600px\\]{
    border-top-left-radius: 1600px;
  }

  .tablet\\:p-4{
    padding: 1rem;
  }

  .tablet\\:p-6{
    padding: 1.5rem;
  }

  .tablet\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .tablet\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .tablet\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .tablet\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .tablet\\:pb-6{
    padding-bottom: 1.5rem;
  }

  .tablet\\:pb-8{
    padding-bottom: 2rem;
  }

  .tablet\\:pb-\\[32px\\]{
    padding-bottom: 32px;
  }

  .tablet\\:pb-\\[40px\\]{
    padding-bottom: 40px;
  }

  .tablet\\:pb-\\[46px\\]{
    padding-bottom: 46px;
  }

  .tablet\\:pb-\\[80px\\]{
    padding-bottom: 80px;
  }

  .tablet\\:pl-10{
    padding-left: 2.5rem;
  }

  .tablet\\:pl-5{
    padding-left: 1.25rem;
  }

  .tablet\\:pr-4{
    padding-right: 1rem;
  }

  .tablet\\:pt-\\[56px\\]{
    padding-top: 56px;
  }

  .tablet\\:text-left{
    text-align: left;
  }

  .tablet\\:text-\\[28px\\]{
    font-size: 28px;
  }

  .tablet\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .tablet\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .tablet\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .tablet\\:font-normal{
    font-weight: 400;
  }

  .tablet\\:leading-snug{
    line-height: 1.375;
  }
}

@media (min-width: 767px){

  .min-\\[767px\\]\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .min-\\[767px\\]\\:gap-x-6{
    column-gap: 1.5rem;
  }
}

@media (min-width: 768px){

  .md\\:max-w-\\[420px\\]{
    max-width: 420px;
  }
}

@media (min-width: 1280px){

  .desktop\\:top-\\[-80px\\]{
    top: -80px;
  }

  .desktop\\:top-\\[64px\\]{
    top: 64px;
  }

  .desktop\\:mx-auto{
    margin-left: auto;
    margin-right: auto;
  }

  .desktop\\:mb-6{
    margin-bottom: 1.5rem;
  }

  .desktop\\:mb-8{
    margin-bottom: 2rem;
  }

  .desktop\\:mb-\\[32px\\]{
    margin-bottom: 32px;
  }

  .desktop\\:mb-\\[48px\\]{
    margin-bottom: 48px;
  }

  .desktop\\:ml-4{
    margin-left: 1rem;
  }

  .desktop\\:ml-6{
    margin-left: 1.5rem;
  }

  .desktop\\:ml-auto{
    margin-left: auto;
  }

  .desktop\\:mr-3{
    margin-right: 0.75rem;
  }

  .desktop\\:mr-6{
    margin-right: 1.5rem;
  }

  .desktop\\:mr-\\[40px\\]{
    margin-right: 40px;
  }

  .desktop\\:mt-\\[40px\\]{
    margin-top: 40px;
  }

  .desktop\\:mt-\\[80px\\]{
    margin-top: 80px;
  }

  .desktop\\:mt-\\[88px\\]{
    margin-top: 88px;
  }

  .desktop\\:block{
    display: block;
  }

  .desktop\\:hidden{
    display: none;
  }

  .desktop\\:h-\\[145px\\]{
    height: 145px;
  }

  .desktop\\:h-\\[250px\\]{
    height: 250px;
  }

  .desktop\\:h-\\[32px\\]{
    height: 32px;
  }

  .desktop\\:h-\\[40px\\]{
    height: 40px;
  }

  .desktop\\:h-\\[500px\\]{
    height: 500px;
  }

  .desktop\\:h-\\[56px\\]{
    height: 56px;
  }

  .desktop\\:h-\\[64px\\]{
    height: 64px;
  }

  .desktop\\:max-h-\\[24px\\]{
    max-height: 24px;
  }

  .desktop\\:max-h-\\[640px\\]{
    max-height: 640px;
  }

  .desktop\\:w-6\\/12{
    width: 50%;
  }

  .desktop\\:w-\\[120px\\]{
    width: 120px;
  }

  .desktop\\:w-\\[250px\\]{
    width: 250px;
  }

  .desktop\\:w-\\[350px\\]{
    width: 350px;
  }

  .desktop\\:w-\\[40px\\]{
    width: 40px;
  }

  .desktop\\:w-\\[900px\\]{
    width: 900px;
  }

  .desktop\\:max-w-\\[24px\\]{
    max-width: 24px;
  }

  .desktop\\:max-w-\\[350px\\]{
    max-width: 350px;
  }

  .desktop\\:max-w-\\[830px\\]{
    max-width: 830px;
  }

  .desktop\\:max-w-full{
    max-width: 100%;
  }

  .desktop\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .desktop\\:flex-row-reverse{
    flex-direction: row-reverse;
  }

  .desktop\\:flex-col{
    flex-direction: column;
  }

  .desktop\\:justify-start{
    justify-content: flex-start;
  }

  .desktop\\:gap-10{
    gap: 2.5rem;
  }

  .desktop\\:gap-3{
    gap: 0.75rem;
  }

  .desktop\\:gap-5{
    gap: 1.25rem;
  }

  .desktop\\:gap-8{
    gap: 2rem;
  }

  .desktop\\:gap-x-8{
    column-gap: 2rem;
  }

  .desktop\\:gap-y-16{
    row-gap: 4rem;
  }

  .desktop\\:bg-\\[\\#F9F9F9\\]{
    --tw-bg-opacity: 1;
    background-color: rgb(249 249 249 / var(--tw-bg-opacity));
  }

  .desktop\\:p-6{
    padding: 1.5rem;
  }

  .desktop\\:p-7{
    padding: 1.75rem;
  }

  .desktop\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }

  .desktop\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .desktop\\:py-6{
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .desktop\\:pb-8{
    padding-bottom: 2rem;
  }

  .desktop\\:pb-\\[40px\\]{
    padding-bottom: 40px;
  }

  .desktop\\:pb-\\[64px\\]{
    padding-bottom: 64px;
  }

  .desktop\\:pb-\\[80px\\]{
    padding-bottom: 80px;
  }

  .desktop\\:pl-16{
    padding-left: 4rem;
  }

  .desktop\\:pl-7{
    padding-left: 1.75rem;
  }

  .desktop\\:pl-\\[52px\\]{
    padding-left: 52px;
  }

  .desktop\\:pt-10{
    padding-top: 2.5rem;
  }

  .desktop\\:pt-\\[100px\\]{
    padding-top: 100px;
  }

  .desktop\\:pt-\\[40px\\]{
    padding-top: 40px;
  }

  .desktop\\:pt-\\[60px\\]{
    padding-top: 60px;
  }

  .desktop\\:pt-\\[64px\\]{
    padding-top: 64px;
  }

  .desktop\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .desktop\\:text-\\[28px\\]{
    font-size: 28px;
  }

  .desktop\\:text-\\[36px\\]{
    font-size: 36px;
  }

  .desktop\\:text-\\[40px\\]{
    font-size: 40px;
  }

  .desktop\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .desktop\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .desktop\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

.\\[\\&_\\#header-bar\\]\\:\\!hidden #header-bar{
  display: none !important;
}

.\\[\\&_\\.information-container\\]\\:\\!pt-0\\.5 .information-container{
  padding-top: 0.125rem !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,0BAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;QAAA;YAAA,mDAAc;YAAd,sBAAc;QAAA;IAAA;;AAAd;QAAA;YAAA,mDAAc;YAAd,sBAAc;QAAA;IAAA;;AAAd;QAAA;YAAA,mDAAc;YAAd,uBAAc;QAAA;IAAA;;AAAd;IAAA,uBAAc;IAAd,4BAAc;;IAAd,iBAAc;IAAd,iCAAc;;IAAd,oBAAc;IAAd,oCAAc;;IAAd,kBAAc;IAAd,iCAAc;;IAAd,oBAAc;IAAd,yCAAc;;IAAd,sBAAc;IAAd,qCAAc;;IAAd,uBAAc;IAAd,sCAAc;;IAAd,4BAAc;IAAd,qCAAc;;IAAd,2BAAc;IAAd,0BAAc;IAAd,sBAAc;;IAAd,gBAAc;;MAAd,0CAAc;MAAd,eAAc;MAAd,oBAAc;;MAAd,kBAAc;EAAA;;AAAd;EAAA,gCAAc;EAAd;AAAc;;AAAd;EAAA,wCAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AAEd;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mCAAmB;IAAnB;EAAmB;AAAA;AAAnB;;EAAA;IAAA,kCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;;AAJnB;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA,mBAyGA;EAzGA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA,kBAyGA;EAzGA;AAyGA;;AAzGA;EAAA,kBAyGA;EAzGA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA,sBAyGA;EAzGA,8BAyGA;EAzGA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA,8BAyGA;EAzGA;AAyGA;;AAzGA;EAAA,2GAyGA;EAzGA,yGAyGA;EAzGA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA,kBAyGA;EAzGA;AAyGA;;AAzGA;EAAA,8BAyGA;EAzGA;AAyGA;;AAzGA;EAAA,2GAyGA;EAzGA,yGAyGA;EAzGA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA,kBAyGA;EAzGA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA,mBAyGA;EAzGA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA,oBAyGA;EAzGA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA,oBAyGA;EAzGA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA,oBAyGA;EAzGA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA,qBAyGA;EAzGA;AAyGA;;AAzGA;EAAA,gDAyGA;EAzGA;AAyGA;;AAzGA;EAAA,iDAyGA;EAzGA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA,qBAyGA;EAzGA,yBAyGA;EAzGA,2BAyGA;EAzGA,yBAyGA;EAzGA,0BAyGA;EAzGA,+BAyGA;EAzGA;AAyGA;;AAzGA;EAAA,oBAyGA;EAzGA,yBAyGA;EAzGA,0BAyGA;EAzGA,wBAyGA;EAzGA,yBAyGA;EAzGA,8BAyGA;EAzGA;AAyGA;;AAzGA;EAAA,oBAyGA;EAzGA,yBAyGA;EAzGA,0BAyGA;EAzGA,wBAyGA;EAzGA,yBAyGA;EAzGA,8BAyGA;EAzGA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA;;AAzGA;;EAAA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;AAAA;;AAzGA;;EAAA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA,gBAyGA;IAzGA;EAyGA;;EAzGA;IAAA,iBAyGA;IAzGA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA,qBAyGA;IAzGA;EAyGA;;EAzGA;IAAA,oBAyGA;IAzGA;EAyGA;;EAzGA;IAAA,kBAyGA;IAzGA;EAyGA;;EAzGA;IAAA,iBAyGA;IAzGA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA,eAyGA;IAzGA;EAyGA;;EAzGA;IAAA,mBAyGA;IAzGA;EAyGA;;EAzGA;IAAA,kBAyGA;IAzGA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;AAAA;;AAzGA;;EAAA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;AAAA;;AAzGA;;EAAA;IAAA;EAyGA;AAAA;;AAzGA;;EAAA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA,iBAyGA;IAzGA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA,kBAyGA;IAzGA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA,iBAyGA;IAzGA;EAyGA;;EAzGA;IAAA,qBAyGA;IAzGA;EAyGA;;EAzGA;IAAA,mBAyGA;IAzGA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA,iBAyGA;IAzGA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA;EAyGA;;EAzGA;IAAA,eAyGA;IAzGA;EAyGA;;EAzGA;IAAA,mBAyGA;IAzGA;EAyGA;;EAzGA;IAAA,kBAyGA;IAzGA;EAyGA;AAAA;;AAzGA;EAAA;AAyGA;;AAzGA;EAAA;AAyGA","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n    @media screen and (max-width: 768px) {\n        .background {\n            background: url(\"assets/images/bg.png\");\n            background-size: 800px;\n        }\n    }\n\n    @media screen and (max-width: 1024px) {\n        .background {\n            background: url(\"assets/images/bg.png\");\n            background-size: 800px;\n        }\n    }\n\n    @media screen and (min-width: 1025px) {\n        .background {\n            background: url(\"assets/images/bg.png\");\n            background-size: 1000px;\n        }\n    }\n  :root {\n    --background: 0 0% 100%;\n    --foreground: 222.2 84% 4.9%;\n\n    --card: 0 0% 100%;\n    --card-foreground: 222.2 84% 4.9%;\n\n    --popover: 0 0% 100%;\n    --popover-foreground: 222.2 84% 4.9%;\n\n    --primary: #0193EB;\n    --primary-foreground: 210 40% 98%;\n\n    --secondary: #2C2C2C;\n    --secondary-foreground: 222.2 47.4% 11.2%;\n\n    --muted: 210 40% 96.1%;\n    --muted-foreground: 215.4 16.3% 46.9%;\n\n    --accent: 210 40% 96.1%;\n    --accent-foreground: 222.2 47.4% 11.2%;\n\n    --destructive: 0 84.2% 60.2%;\n    --destructive-foreground: 210 40% 98%;\n\n    --border: 214.3 31.8% 91.4%;\n    --input: 214.3 31.8% 91.4%;\n    --ring: 222.2 84% 4.9%;\n\n    --radius: 0.5rem;\n\n      --modal-background: rgba(44, 44, 44, 0.32);\n      --gray: #667A8B;\n      --text-gray: #8A8B9A;\n\n      --success: #3ED078;\n  }\n\n  .dark {\n    --background: 222.2 84% 4.9%;\n    --foreground: 210 40% 98%;\n\n    --card: 222.2 84% 4.9%;\n    --card-foreground: 210 40% 98%;\n\n    --popover: 222.2 84% 4.9%;\n    --popover-foreground: 210 40% 98%;\n\n    --primary: 210 40% 98%;\n    --primary-foreground: 222.2 47.4% 11.2%;\n\n    --secondary: 217.2 32.6% 17.5%;\n    --secondary-foreground: 210 40% 98%;\n\n    --muted: 217.2 32.6% 17.5%;\n    --muted-foreground: 215 20.2% 65.1%;\n\n    --accent: 217.2 32.6% 17.5%;\n    --accent-foreground: 210 40% 98%;\n\n    --destructive: 0 62.8% 30.6%;\n    --destructive-foreground: 210 40% 98%;\n\n    --border: 217.2 32.6% 17.5%;\n    --input: 217.2 32.6% 17.5%;\n    --ring: 212.7 26.8% 83.9%;\n  }\n}\n\n@layer base {\n  * {\n      @apply border-border;\n      @apply font-inter;\n  }\n  body {\n    @apply bg-background text-secondary;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
